export const CreditCardTypes = [
  ['AX', 'amex'],
  ['DC', 'diners'],
  ['JC', 'jcb'],
  ['MC', 'master'],
  ['VI', 'visa'],
  ['DI', 'discover'],
  ['UP', 'chinaup'],
  ['VIC', 'visa-cobrand'],
];
